/* eslint-disable */
import React from 'react'

function Border({ settings, mainPanelBackground = '#fff' }) {
    let background

    if (settings.mainPanelBackground === 'none') {
        background = 'none'
    } else if (
        settings.mainPanelBackground &&
        settings.mainPanelBackground.indexOf('#') > -1
    ) {
        background = mainPanelBackground
    } else if (settings.mainPanelBackground) {
        background = `url('#${settings.mainPanelBackground}')`
    } else {
        background = '#fff'
    }

    return (
        <rect
            width={settings.svgWidth}
            height={settings.svgHeight}
            fill={background}
            stroke={settings.mainPanelStroke || '#c2c2c2'}
        />
    )
}

export default Border
